import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchBar = ({ 
  placeholder = "Search...", 
  value, 
  onChange, 
  onClear, 
  width = 300,
  label,
  fullWidth,
  autoFocus,
  sx = {}
}) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      value={value}
      onChange={onChange}
      size="small"
      sx={{
        width: width,
        maxWidth: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: 0,
        },
        ...sx
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "#666", fontSize: "20px", marginRight: "8px" }} />
          </InputAdornment>
        ),
        endAdornment: value && onClear && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClear}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
